import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import Card from "../../components/Card/Card";
import useAuth from "../../hooks/useAuth";
import { submitBusinessPlanSchema } from "../../services/SchemaService";
import { Button, Form, Loading, Tabs, Tab } from "carbon-components-react";
import CancelButton from "../../components/Buttons/CancelButton";
import { ButtonSet } from "carbon-components-react";
import { Checkmark24 } from "@carbon/icons-react";
import { ArrowRight20 } from "@carbon/icons-react";
import { ArrowLeft20 } from "@carbon/icons-react";
import useBusinessPlan from "../../hooks/useBusinessPlan";
import MarketAnalysisForm from "../../components/Forms/MarketAnalysisForm";
import WorkersForm from "../../components/Forms/WorkersForm";
import FinancialPlanForm from "../../components/Forms/FinancialPlanForm";
import EnvironmentalSocialAnalysisForm from "../../components/Forms/EnvironmentalSocialAnalysisForm";
import DataSheetForm from "../../components/Forms/DataSheetForm";
import ExistingBusinessProfileForm from "../../components/Forms/ExistingBusinessProfileForm";

const JuryBusinessPlanPage = () => {
  const params = useParams();
  const [uuid] = useState(params.uuid);
  const { businessPlan, isLoading: businessPlanLoading } =
    useBusinessPlan(uuid);
  const [hasBusinessCurrently, setHasBusinessCurrently] = useState(null);
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(0);

  const navigate = useNavigate();

  const {
    register,
    reset,
    getValues,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(submitBusinessPlanSchema),
  });

  useEffect(() => {
    if (
      !businessPlanLoading &&
      businessPlan &&
      Object.keys(businessPlan).length > 0
    ) {
      reset(businessPlan);
      setHasBusinessCurrently(businessPlan.hasBusinessCurrently);
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
  }, [uuid, businessPlan, businessPlanLoading, reset]);

  const nextTab = () => {
    setActiveTab((prev) => prev + 1);
  };

  const previousTab = () => {
    setActiveTab((prev) => prev - 1);
  };

  return (
    <>
      <Loading
        active={isLoading}
        description="Active loading indicator"
        withOverlay={true}
      />
      <Card title="Plano de Negócio">
        <Form>
          <Tabs
            scrollIntoView={false}
            selected={activeTab}
            type={"container"}
            onSelectionChange={(e) => setActiveTab(e)}
          >
            {/* <Tab href="#" id="tab-1" label="SECÇÃO 1">
              <DataSheetForm
                register={register}
                control={control}
                errors={errors}
                disabled={true}
                businessPlan={businessPlan}
                hasBusinessCurrently={hasBusinessCurrently}
                setHasBusinessCurrently={setHasBusinessCurrently}
                setValue={setValue}
                getValues={getValues}
              />
              <div className="tab-navigation">
                <Button kind="ghost" size="sm" onClick={nextTab}>
                  Próximo <ArrowRight20 />
                </Button>
              </div>
            </Tab> */}

            <Tab href="#" id="tab-2" label="SECÇÃO 2">
              <ExistingBusinessProfileForm
                register={register}
                control={control}
                errors={errors}
                setHasBusinessCurrently={setHasBusinessCurrently}
                disabled={true}
                businessPlan={businessPlan}
              />
              <div className="tab-navigation">
                {/* <Button kind="ghost" size="sm" onClick={previousTab}>
                  <ArrowLeft20 /> Anterior
                </Button> */}
                <Button kind="ghost" size="sm" onClick={nextTab}>
                  Próximo <ArrowRight20 />
                </Button>
              </div>
            </Tab>

            <Tab href="#" id="tab-3" label="SECÇÃO 3">
              <MarketAnalysisForm
                register={register}
                errors={errors}
                disabled={true}
              />
              <div className="tab-navigation">
                <Button kind="ghost" size="sm" onClick={previousTab}>
                  <ArrowLeft20 /> Anterior
                </Button>
                <Button kind="ghost" size="sm" onClick={nextTab}>
                  Próximo <ArrowRight20 />
                </Button>
              </div>
            </Tab>

            <Tab href="#" id="tab-4" label="SECÇÃO 4">
              <WorkersForm
                register={register}
                errors={errors}
                disabled={true}
                control={control}
                getValues={getValues}
                businessPlan={businessPlan}
              />
              <div className="tab-navigation">
                <Button kind="ghost" size="sm" onClick={previousTab}>
                  <ArrowLeft20 /> Anterior
                </Button>
                <Button kind="ghost" size="sm" onClick={nextTab}>
                  Próximo <ArrowRight20 />
                </Button>
              </div>
            </Tab>

            <Tab href="#" id="tab-5" label="SECÇÃO 5">
              <FinancialPlanForm
                register={register}
                control={control}
                errors={errors}
                disabled={true}
                businessPlan={businessPlan}
                getValues={getValues}
                setValue={setValue}
              />
              <div className="tab-navigation">
                <Button kind="ghost" size="sm" onClick={previousTab}>
                  <ArrowLeft20 /> Anterior
                </Button>
                <Button kind="ghost" size="sm" onClick={nextTab}>
                  Próximo <ArrowRight20 />
                </Button>
              </div>
            </Tab>

            <Tab href="#" id="tab-6" label="SECÇÃO 6">
              <EnvironmentalSocialAnalysisForm
                businessPlan={businessPlan}
                register={register}
                errors={errors}
                disabled={true}
              />
              <div className="tab-navigation">
                <Button kind="ghost" size="sm" onClick={previousTab}>
                  <ArrowLeft20 /> Anterior
                </Button>
              </div>
            </Tab>
          </Tabs>
          <div className="form-buttons">
            <ButtonSet>
              <Link
                className="bx--btn bx--btn--primary"
                to={"../pontuar-plano-de-negocio/" + uuid}
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginRight: "8px" }}
              >
                <Checkmark24 style={{ marginRight: "8px" }} />
                Pontuar
              </Link>
              <CancelButton label={"Voltar"} navigateTo={""} />
            </ButtonSet>
          </div>
        </Form>
      </Card>
    </>
  );
};

export default JuryBusinessPlanPage;
